import { getIn } from "formik";

export const getInForm = (formValues: any, key: string) => {
  return getIn(formValues, key);
};
